import React from 'react';
import { FormInput } from 'shards-react';

interface FormExportProps {
  labelCustomer: string;
  valueCustomer: string;
  invalidCustomer: boolean;
  disabledCustomer: boolean;
  onChangeCustomer: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormExport = ({ labelCustomer, valueCustomer, invalidCustomer, disabledCustomer, onChangeCustomer }: FormExportProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {/* 需要家 */}
      <label htmlFor="customer">{labelCustomer}</label>
      <FormInput id="customer" className="mb-3" disabled={disabledCustomer} value={valueCustomer} invalid={invalidCustomer} onChange={onChangeCustomer} />
    </>
  );
};

export default FormExport;
